import SetRekSubStatusModal from "./SetRekSubStatusModal";

export default SetRekSubStatusModal;
